import React, { useEffect, useMemo, useState } from 'react';
import client from 'utils/client';
import { t } from 'ttag';

export default function App() {
  const siteId = useMemo(() => window?.siteId || 11, []);

  const [topCategories, setTopCategories] = useState(
    /** @type {Array<{title: string, slug: string, page_views: number}>} */ []
  );

  useEffect(() => {
    const controller = new AbortController();
    client
      .get(`/navigation/top_categories/${siteId}/`, {
        signal: controller.signal
      })
      .then(({ data }) => {
        if (data) {
          setTopCategories(data.top_categories);
        }
      })
      .catch(error => {
        if (error.name !== 'AbortError') {
          // console.error(error);
        }
      });

    return () => controller.abort();
  }, []);

  return (
    <section className="container min-h-[192px] p-0 sm:p-2">
      <h2 className="m-0 mb-4 grid p-0 text-left text-lg font-semibold text-black before:mb-4 before:h-[1px] before:bg-gray/80 before:content-['']">{t`Popular Categories`}</h2>
      <ul className="m-0 grid list-none grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-x-4 md:grid-cols-4 lg:grid-cols-6">
        {topCategories.length > 0 &&
          topCategories.map(({ title, slug }) => (
            <li key={slug} className="line-clamp-1 text-sm">
              <a
                href={`/${slug}`}
                className="text-dark-gray no-underline hover:underline"
              >
                {title}
              </a>
            </li>
          ))}
      </ul>
    </section>
  );
}
